/**
 * @fileoverview
 * Handles the "cookie settings" link by attaching an event listener that, when clicked,
 * prevents the default anchor navigation and opens the CookieScript preferences panel
 * (if CookieScript is available).
 *
 * @author Benny Ackermann <b.ackermann@ivario.com>
 * @date 2025-07-25
 */

document.addEventListener('DOMContentLoaded', function() {

  /**
   * The anchor element that points to "/#cookie-settings".
   * @type {HTMLAnchorElement|null}
   */
  const cookieSettingsLink = document.querySelector('a[href$="/#cookie-settings"]');

  if (cookieSettingsLink) {

    /**
     * Handles clicks on the cookie settings link.
     * Prevents the default behavior and opens the CookieScript modal if available.
     *
     * @param {MouseEvent} event - The click event.
     */
    cookieSettingsLink.addEventListener('click', function(event) {
      event.preventDefault();

      // If CookieScript is loaded and available, open the preferences panel.
      if (typeof CookieScript !== 'undefined' && CookieScript.instance) {
        CookieScript.instance.show();
      }
      else {
        console.log('CookieScript not available.')
      }
    });
  }
});